import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { Sku } from '@app/api/models/sku';
import { booleanBodyRender, TableColumn } from '@app/components/common/table';

import { SkuLookups } from './types';

export const useColumns = ({
  lookups,
  onEdit,
  canChange,
}: {
  lookups: SkuLookups;
  onEdit: (sku: Sku) => void;
  canChange: boolean;
}): TableColumn<Sku>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: { type: 'text', name: 'pid' },
        sort: true,
      },
    },
    {
      name: 'title',
      label: 'Наименование',
      options: {
        filter: { type: 'text', name: 'title' },
        sort: true,
      },
    },
    {
      name: 'brand',
      label: 'Бренд',
      options: {
        filter: { type: 'text', name: 'brand' },
        sort: true,
      },
    },
    {
      name: 'category_id',
      label: 'Категория',
      options: {
        filter: {
          type: 'select',
          name: 'category_id',
          onOptionsFetch: () => lookups.categories,
        },
        sort: true,
        customBodyRender: (value: number) => <span>{lookups.categoriesById[value] || '—'}</span>,
      },
    },
    {
      name: 'subcategory_id',
      label: 'Подкатегория',
      options: {
        filter: {
          type: 'select',
          name: 'subcategory_id',
          onOptionsFetch: () => lookups.subcategories,
        },
        sort: true,
        customBodyRender: (value: number) => <span>{lookups.subcategoriesById[value] || '—'}</span>,
      },
    },
    {
      name: 'unit_id',
      label: 'Ед. изм.',
      options: {
        filter: {
          type: 'select',
          name: 'unit_id',
          onOptionsFetch: () => lookups.units,
        },
        sort: true,
        customBodyRender: (value: number) => <span>{lookups.unitsById[value] || '—'}</span>,
      },
    },
    {
      name: 'is_active',
      label: 'Активен',
      options: {
        filter: { type: 'boolean', name: 'is_active' },
        sort: true,
        customBodyRender: booleanBodyRender(),
      },
    },
    ...(canChange
      ? ([
          {
            name: 'id',
            label: 'Действия',
            options: {
              filter: false,
              sort: false,
              customBodyRender: (id, { rowData }) => (
                <Flex gap={2}>
                  <Tooltip label="Редактировать">
                    <IconButton
                      name="edit"
                      onClick={() => onEdit(rowData as Sku)}
                      aria-label="edit"
                      size="sm"
                    >
                      <MdEdit />
                    </IconButton>
                  </Tooltip>
                </Flex>
              ),
            },
          },
        ] as TableColumn<Sku>[])
      : []),
  ];
};
